import { FORM_META_SET_SCHEMA, FORM_META_CLEAR_SCHEMA } from './types'

export const setFormSchema = (formName, schema) => ({
  type: FORM_META_SET_SCHEMA,
  payload: { formName, schema },
})

export const clearFormSchema = (formName) => ({
  type: FORM_META_CLEAR_SCHEMA,
  payload: { formName },
})
